"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.affiliationFactory = void 0;
const Factory = require("factory.ts");
const mocks_1 = require("../../../mocks");
const organization_factory_1 = require("./organization.factory");
const credential_factory_1 = require("./credential.factory");
const batch_affiliation_document_factory_1 = require("./batch-affiliation-document.factory");
exports.affiliationFactory = Factory.Sync.makeFactory({
    id: Factory.each(i => i + 1),
    parent_organization_id: mocks_1.orgNgb.id,
    child_organization_id: mocks_1.orgClub.id,
    parent_organization: organization_factory_1.organizationFactory.build({
        id: mocks_1.orgNgb.id, name: mocks_1.orgNgb.name
    }),
    child_organization: organization_factory_1.organizationFactory.build({
        id: mocks_1.orgClub.id, name: mocks_1.orgClub.name
    }),
    credentials: [credential_factory_1.credentialFactory.build()],
    batch_affiliation_document_id: batch_affiliation_document_factory_1.batchAffiliationDocumentFactory.build().id
});
